import https from "../utils/http";
//
/**
 *  首页相关接口
 */

/** 获取首页1920*540大轮播 + banner上菜单栏*/
export function getIndexTop(params) {
  return https.get(`/index/banner`, params);
}

/** 获取首页秒杀数据*/
export function getIndexSeckill(params) {
  return https.get(`/index/goods_cache`, params);
}

/** 获取首页顶部图片*/
export function getIndexdingbu(params) {
  return https.get(`/index/goods_dingbu`, params);
}

/** 获取首页今日特价数据*/
export function getDailySpecial(params) {
  return https.get(`/index/specialOffer`, params);
}

/** 获取首页新品图片*/
export function getNewImg(params) {
  return https.get(`/index/new_banner`, params);
}

/** 获取首页品牌折扣数据*/
export function getBrandDiscount(params) {
  return https.get(`/index/buySwapDiscount`, params);
}

/** 获取首页中间层数据*/
export function getIndexCenter(params) {
  return https.get(`/index/index`, params);
}

/** 获取首页品牌专区数据*/
export function getBrandList(params) {
  return https.get(`/index/ppzq`, params);
}
/** 获取首页品牌专区数据*/
export function indexCosmetics(params) {
  return https.get(`/index/Cosmetics`, params);
}

/** 获取首页每周特价数据*/
export function getWeeklyList(params) {
  return https.get(`/index/chosen`, params);
}

/** 获取首页弹框数据*/
export function getIndexBulletFrame(params) {
  return https.get(`/index/bulletframe`, params);
}

/** 获取首页包邮商品数据*/
export function getIndexfreeShippingGoods(params) {
  return https.get(`/index/free_shipping`, params);
}

/** 获取首页组合套餐数据*/
export function getIndexPackagelist(params) {
  return https.get(`/index/getPackagelist`, params);
}

// export function getIndexSpecial(params) {
//   return https.get(`/index/xlSpecialProvision`, params);
// }










// WEBPACK FOOTER //
// ./src/api/index.js